import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-delete-dialog',
  templateUrl: './edit-delete-dialog.component.html',
  styleUrls: ['./edit-delete-dialog.component.scss']
})
export class EditDeleteDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
